import { useEffect, useState } from "react";

export function useCameraPermission() {
  const [cameraPermission, setCameraPermission] = useState<PermissionState | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function checkPermission() {
      try {
        // Try Permissions API first
        if (navigator.permissions) {
          const result = await navigator.permissions.query({ name: "camera" as PermissionName });
          if (isMounted) {
            setCameraPermission(result.state);
            result.onchange = () => {
              setCameraPermission(result.state);
            };
          }
        } else {
          // Fallback: Try requesting getUserMedia to infer permission
          await navigator.mediaDevices.getUserMedia({ video: true });
          if (isMounted) setCameraPermission("granted");
        }
      } catch (err) {
        if (isMounted) setCameraPermission("denied");
      }
    }

    checkPermission();

    return () => {
      isMounted = false;
    };
  }, []);

  return cameraPermission; // 'granted' | 'denied' | 'prompt' | null
}